import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { quarterlyFeedback } from '@app/shared/constants/global.enum';
import { EmeraldButtonModule } from '@emerald-angular/button';
import { EmeraldDropdownModule } from '@emerald-angular/dropdown';
import { EmeraldIconModule } from '@emerald-angular/icon';

@Component({
  selector: 'app-file-upload',
  standalone: true,
  imports: [
    CommonModule,
    EmeraldButtonModule,
    EmeraldDropdownModule,
    EmeraldIconModule,
  ],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploadComponent),
      multi: true,
    },
  ],
})
export class FileUploadComponent {
  @Input() label = '';
  @Input() error: string | null = null;
  @Input() selectedFile: File | null = null;
  @Input() existingFileUrl: string = '';
  @Input() fileName: string = '';
  @Output() fileSelected = new EventEmitter<File>();
  @Output() fileRemoved = new EventEmitter<void>();
  @Input() isSubmitted = false;
  @Input() fileTypeText?: string;
  @Input() accept?: string;

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  resetFileInput() {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  isDisabled = false;
  quarterlyFeedback = quarterlyFeedback;

  private onChange: (value: File | null) => void = () => {};
  private onTouched: () => void = () => {};

  handleFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    console.log(this.error);
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.selectedFile = file;
      this.fileSelected.emit(file);
      this.onChange(file);
      this.onTouched();
    }
  }

  removeFile() {
    this.selectedFile = null;
    this.existingFileUrl = '';
    this.fileName = '';
    this.fileRemoved.emit();
    this.onChange(null);
    this.onTouched();
  }

  getFileNameFromUrl(url: string): string {
    if (!url) return '';
    try {
      const urlParts = url.split('/');
      return urlParts[urlParts.length - 1] || '';
    } catch (error) {
      return '';
    }
  }

  writeValue(value: File | null): void {
    this.selectedFile = value;
  }
  registerOnChange(fn: (value: File | null) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 KB';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}
